<template>

  <br>
  <br>
  <br>
  <br>

  <div class="px-1 position-fixed bottom-0 w-100 max_width">
  <div dir="rtl" class="navbar bg-color rounded-pill">

    <router-link :to="{name:'HomePage'}" class="navbar_items">
      <div style="width: fit-content" :class="page === 'HomePage' ? 'font-color_light' : 'text-white' "
           class="p-2 d-flex justify-content-center align-items-center rounded-circle">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-house icon-size-2" viewBox="0 0 16 16">
          <path
              d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/>
        </svg>
      </div>

      <p class="font-5 text-center" :class="page === 'HomePage' ? 'font-color_light font-bold' : 'text-white' ">
        خانه
      </p>
    </router-link>

    <router-link :to="{name:'ProductsManagement'}" class="navbar_items">
      <div style="width: fit-content" :class="page === 'ProductsManagement' ? 'font-color_light' : 'text-white' "
           class="p-2 d-flex justify-content-center align-items-center rounded-circle">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-boxes icon-size-2" viewBox="0 0 16 16">
          <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z"/>
        </svg>
      </div>

      <p class="font-5 m-0 font-color-white text-center text-nowrap" :class="page === 'ProductsManagement' ? 'font-color_light' : 'text-white' ">
        مدیریت محصولات
      </p>
    </router-link>

    <router-link :to="{name:'MyOrders'}" class="navbar_items">
      <div style="width: fit-content" :class="page === 'MyOrders' ? 'font-color_light' : 'text-white' "
           class="p-2 d-flex justify-content-center align-items-center rounded-circle">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-bag-check icon-size-2" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
          <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"/>
        </svg>
      </div>

      <p class="font-5 text-center text-nowrap" :class="page === 'MyOrders' ? 'font-color_light' : 'text-white' ">
        سفارشات
      </p>
    </router-link>

    <router-link :to="{name:'OffersPage'}" class="navbar_items">
      <div style="width: fit-content" :class="page === 'OffersPage' ? 'font-color_light' : 'text-white' "
           class="p-2 d-flex justify-content-center align-items-center rounded-circle">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-bag-plus-fill icon-size-2" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0M8.5 8a.5.5 0 0 0-1 0v1.5H6a.5.5 0 0 0 0 1h1.5V12a.5.5 0 0 0 1 0v-1.5H10a.5.5 0 0 0 0-1H8.5z"/>
        </svg>
      </div>

      <p class="font-5 m-0 font-color-white text-center" :class="page === 'OffersPage' ? 'font-color_light' : 'text-white' ">
        پیشنهاد خرید
      </p>
    </router-link>

  </div>
  </div>

</template>


<script>

import {useRoute} from "vue-router";

export default {

  name: 'BottomNavigation',

  setup() {

    let page = useRoute().name
    

    return {
      page,
      // push_page,
    }
  }
}
</script>


<style scoped>


.navbar {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  max-width: 70rem;
  /*transform: translate(-0.5%, 0);*/
}

.navbar_items {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
}


</style>